import { fetchJson } from '../apiBase';

async function request(path, body) {
  const response = await fetchJson(path, body === undefined ? undefined : {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.detail || 'Turnuva işlemi tamamlanamadı.');
    error.status = response.status;
    throw error;
  }
  return payload;
}

const base = (token) => `/mini-tasks/board/${encodeURIComponent(token)}/tournaments`;

export function getCurrentTournament(token, boardSessionId) {
  return request(`${base(token)}/current?board_session_id=${encodeURIComponent(boardSessionId)}`);
}

export function getTournamentContents(token, boardSessionId) {
  return request(`${base(token)}/contents?board_session_id=${encodeURIComponent(boardSessionId)}`);
}

export function createTournament(token, boardSessionId, studentIds, contentKey = 'mixed') {
  return request(base(token), { board_session_id: boardSessionId, student_ids: studentIds, content_key: contentKey });
}

export function abandonTournament(token, boardSessionId, tournamentId) {
  return request(`${base(token)}/${encodeURIComponent(tournamentId)}/abandon`, {
    board_session_id: boardSessionId,
  });
}

function matchPath(token, tournamentId, matchId) {
  return `${base(token)}/${encodeURIComponent(tournamentId)}/matches/${encodeURIComponent(matchId)}`;
}

export function startTournamentMatch(token, boardSessionId, tournamentId, matchId) {
  return request(`${matchPath(token, tournamentId, matchId)}/start`, { board_session_id: boardSessionId });
}

export function answerTournamentQuestion(token, boardSessionId, tournamentId, matchId, studentId, question) {
  return request(`${matchPath(token, tournamentId, matchId)}/answer`, {
    board_session_id: boardSessionId,
    student_id: studentId,
    phase: question.phase,
    question_index: question.index,
    selected_answer: question.answer,
  });
}

export function finishTournamentMatch(token, boardSessionId, tournamentId, matchId, result) {
  return request(`${matchPath(token, tournamentId, matchId)}/finish`, {
    board_session_id: boardSessionId,
    ...(result || {}),
  });
}

export function finishTournament(token, boardSessionId, tournamentId, matches) {
  return request(`${base(token)}/${encodeURIComponent(tournamentId)}/finish`, {
    board_session_id: boardSessionId, matches,
  });
}
